import icons from '../../public/icons.svg';

export const ICONS_URL = icons;

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;

export const KEY = 'c4edf8fc-a204-4216-bc47-48202d64bb4f';
export const MODAL_CLOSE_SEC = 2.5;
